<template>
  <div class="card summary-card">
    <div class="card-body">
      <!-- Current -->
      <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
        <div>
          <p class="summary-card__section-label mb-1">Current</p>
          <p class="summary-card__product mb-0">{{ display.productName }}</p>
        </div>
        <StatusPill :state="display.pillState" />
      </div>

      <div class="summary-card__row">
        <span class="summary-card__label">Price</span>
        <span class="summary-card__value">{{ display.priceString }}</span>
      </div>
      <div v-if="display.startedOn" class="summary-card__row">
        <span class="summary-card__label">Started on</span>
        <span class="summary-card__value">{{ display.startedOn }}</span>
      </div>

      <!-- Upcoming -->
      <template v-if="display.renewsOn">
        <hr class="summary-card__divider" />
        <p class="summary-card__section-label mb-2">Upcoming</p>
        <div class="summary-card__row">
          <span class="summary-card__label">{{ display.renewsOnLabel }}</span>
          <span class="summary-card__value">{{ display.renewsOn }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import StatusPill from "./StatusPill.vue";
import type { DisplayModel } from "../subscriptionLogic";

defineProps<{ display: DisplayModel }>();
</script>

<style scoped lang="scss">
.summary-card {
  border-radius: 16px;

  &__section-label {
    font-weight: 700;
    font-size: 0.95rem;
  }

  &__product {
    font-weight: 700;
    font-size: 1.05rem;
  }

  &__row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.35rem 0;
  }

  &__label {
    color: var(--text-muted, #b2b2b2);
    font-size: 0.95rem;
  }

  &__value {
    font-weight: 700;
    text-align: right;
  }

  &__divider {
    margin: 1rem 0;
    opacity: 0.15;
  }
}
</style>
